PJQ.views.meetings.MeetingListDatatable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Meetings'
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'data-table-header-meetings')
        },
        paging: false
    },
    events: {},
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['number', 'name', 'description', 'date', 'meetingTime', 'location', 'status'];

        this.options.order = [0, 'desc'];

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "width": "20px",
                        "render": (data, type, row) => {
                            if (type === 'sort' || type === 'type') {
                                return data;
                            }

                            return '<a href="javascript:void(0)" class="btn-edit-punchlist-item">' + data + '</a>';
                        },
                    });
                    break;
                case 'name':
                    columns.push({
                        "columnData": "name",
                        "data": "attributes.name",
                        "title": "Name"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'date':
                    columns.push({
                        "columnData": "date",
                        "data": "attributes.date",
                        "title": 'Meeting Date',
                        "width": '150px',
                        "render": (data, type, row) => {
                            if (_.size(data) === 0) {
                                return '';
                            }
                            return PJQ.helpers.dateHelpers.getDateString(data, PJQ.helpers.dateHelpers.dateFormats.DATE, true)
                        }
                    });
                    break;
                case 'meetingTime':
                    columns.push({
                        "columnData": "meetingTime",
                        "data": "",
                        "title": 'Meeting Time',
                        "width": '150px',
                        "render": (data, type, row) => {
                            return this.parseTimeString(row.get('startTime')) + ' - ' + this.parseTimeString(row.get('endTime')) + ' ' + (row.get('timezone') ?? 'CDT');
                        }
                    });
                    break;
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": (data, type, row) => {
                            return PJQ.constants.meetings.meetingStatusNames[row.get('statusId')]
                        }
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue') && this.customFields) {
                        _.each(this.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue / 100, true)).toFixed(2)
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue / 100, true)).toFixed(2) + '%' : '';
                                                }

                                                break;
                                        }
                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": (data, type, row) => {
                    let html = '<div class="show-on-row-hover">',
                        status = row.get('statusId'),
                        targetMeeting = row,
                        originMeetingId = targetMeeting.get('originMeetingId'),
                        originMeeting = originMeetingId ? targetMeeting.collection.get(originMeetingId) : targetMeeting,
                        mostRecentMeeting = originMeeting ? _.max(originMeeting.followUpMeetings.models, function (model) {
                            return model.id;
                        }) : null;
                    if (this.options.canViewMeetings) {
                        html += '<button type="button" class="btn btn-info btn-view-meeting ml-1" data-cid="' + (row.cid) + '" title="View meeting"><i class="fal fa-arrow-alt-from-left"></i></button>';
                    }
                    if (this.options.canDeleteMeetings && mostRecentMeeting === targetMeeting) {
                        html += '<button type="button" class="btn btn-danger btn-delete-meeting ml-1" data-cid="' + (row.cid) + '" title="Delete meeting"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>'
                    return html
                },
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    parseTimeString: function (timeString) {
        let timeArray = timeString.split(":"), // split the time string into an array
            time = new Date(),
            options = {hour: "numeric", minute: "numeric", hour12: true};
        time.setHours(timeArray[0]); // set the hours
        time.setMinutes(timeArray[1]); // set the minutes
        time.setSeconds(0); // set the seconds
        return time.toLocaleTimeString("en-US", options);
    },
    getFilterData: function () {
        let result = this.options.data,
            statusFilter = this.getFilter('status');
        if (_.size(statusFilter) === 0) {
            return result;
        }

        return _.filter(result, function (row) {
            return _.contains(statusFilter, row.get('statusId'));
        });
    },
});